import {Tone} from "../../../components/kit";

/** Etiquetas en español y tono de los enums del CRM y de redes (#13893): nunca el valor crudo en pantalla. */

export interface Label {
	label: string;
	tone: Tone;
}

export const LEAD_STATUS: Record<string, Label> = {
	NEW: {label: "Nuevo", tone: "info"},
	CONTACTED: {label: "Contactado", tone: "warning"},
	QUALIFIED: {label: "Cualificado", tone: "success"},
	CONVERTED: {label: "Convertido", tone: "success"},
	DISCARDED: {label: "Descartado", tone: "neutral"},
};

export const LEAD_SOURCE: Record<string, string> = {
	WEB_FORM: "Formulario web",
	NEWSLETTER: "Newsletter",
	EMAIL_INBOUND: "Correo entrante",
	REFERRAL: "Referencia",
	IMPORT: "Importación",
	EVENT: "Evento",
	MANUAL: "Manual",
	OUTBOUND: "Prospección",
	SOCIAL: "Redes sociales",
	OTHER: "Otro",
};

export const SOCIAL_POST_STATUS: Record<string, Label> = {
	DRAFT: {label: "Borrador", tone: "neutral"},
	SCHEDULED: {label: "Programado", tone: "info"},
	PUBLISHED: {label: "Publicado", tone: "success"},
	PARTIAL: {label: "Publicado en parte", tone: "warning"},
	FAILED: {label: "Fallido", tone: "error"},
};

export const SOCIAL_PUBLICATION_STATUS: Record<string, Label> = {
	PENDING: {label: "Pendiente", tone: "warning"},
	PUBLISHED: {label: "Publicada", tone: "success"},
	FAILED: {label: "Fallida", tone: "error"},
};

export const SOCIAL_ACCOUNT_STATUS: Record<string, Label> = {
	CONNECTED: {label: "Conectada", tone: "success"},
	EXPIRED: {label: "Caducada", tone: "warning"},
	DISCONNECTED: {label: "Desconectada", tone: "neutral"},
	ERROR: {label: "Error", tone: "error"},
};

export const SOCIAL_PROVIDER: Record<string, string> = {
	FACEBOOK: "Facebook",
	INSTAGRAM: "Instagram",
	LINKEDIN: "LinkedIn",
};

export const ORG_REQUEST_STATUS: Record<string, Label> = {
	DETECTED: {label: "Detectada", tone: "info"},
	PROPOSED: {label: "Propuesta", tone: "warning"},
	WON: {label: "Ganada", tone: "success"},
	LOST: {label: "Perdida", tone: "neutral"},
	LOST_ON_PRICE: {label: "Perdida por precio", tone: "error"},
};

export const CONTACT_EVENT_TYPE: Record<string, string> = {
	CALL: "Llamada",
	EMAIL: "Correo",
	MEETING: "Reunión",
	NOTE: "Nota",
	TASK: "Tarea",
	OTHER: "Otro",
};

export const CONTACT_TYPE: Record<string, string> = {
	LEAD: "Lead",
	PROSPECT: "Prospecto",
	CLIENT: "Cliente",
	PARTNER: "Socio",
	PROVIDER: "Proveedor",
	OTHER: "Otro",
};
